import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function SwipeDone() {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setVisible(true), 100);
    const navTimer  = setTimeout(() => navigate('/onboarding/attraction-quiz', { replace: true }), 3000);
    return () => { clearTimeout(fadeTimer); clearTimeout(navTimer); };
  }, [navigate]);

  return (
    <div style={{
      height: '100vh', background: '#000',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      padding: '0 40px', textAlign: 'center',
      opacity: visible ? 1 : 0, transition: 'opacity 0.8s ease',
    }}>
      <div style={{
        fontSize: 10, letterSpacing: 3, textTransform: 'uppercase',
        color: '#c9a84c', marginBottom: 24,
      }}>
        Attraction Profile Set
      </div>
      <div style={{
        fontFamily: 'var(--font-display)',
        fontSize: 28, fontWeight: 300, color: '#fff', marginBottom: 16,
      }}>
        Your type has been mapped.
      </div>
      <div style={{
        fontFamily: 'var(--font-display)',
        fontStyle: 'italic', fontSize: 14,
        color: 'rgba(255,255,255,0.4)',
      }}>
        We won't ask again.
      </div>
    </div>
  );
}
